import React from 'react'
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import { Link } from "react-router-dom";
import MemberBios from "../elements/service/MemberBios";
import { useTranslation } from "react-i18next";

const CoreTeam = () => {
    const { t } = useTranslation('enterprise');
    return (
        <>
            <SEO title="N01ZET Team - l'équipe N01ZET - Victor DEGBO - Valérie CAILLAUD - Marie-Héléne MORVAN - Anne-Marie CALMEIL - Philippe BOISDELET - Guy ROULLIER - Hugues FEYRIT - Gustavo HORNOS" />
            <main className="page-wrapper">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/*  Start Core Team  */}
                <div className="rn-service-area rn-section-gap member-display">
                    <div className="container">
                        <div className="row pb-5 mb-5 bios-title-header">
                            <div className="col-lg-12 text-center">
                            <h2 className='title'>{t('WhoAreWe.CoreTeam')}</h2>
                            </div>
                        </div>
                        <MemberBios
                            image = "/images/team/member1.png"
                            link = "https://www.linkedin.com/in/victor-degbo-83266b2"
                            title = "Victor Degbo"
                            description = {t('core.function.vic')}
                            text1 = {t('core.vic.text1')}
                            text2 = {t('core.vic.text2')}
                            text3 = {t('core.vic.text3')}
                            />
                    </div>
                </div>
                {/* Start Member2 */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <MemberBios
                            image = "/images/team/member2.png"
                            link = "https://www.linkedin.com/in/philippe-boisselet-b87813"
                            title = "Philippe Boisselet"
                            description = {t('core.function.val')}
                            text1 = {t('core.phi.text1')}
                            text2 = {t('core.phi.text2')}
                            text3 = {t('core.phi.text3')}
                            />
                    </div>
                </div>
                {/* End Member2 */}

                {/* Start Member3 */}
                <div className="rn-service-area rn-section-gap member-display">
                    <div className="container">
                        <MemberBios
                            image = "/images/team/member3.png"
                            link = "https://www.linkedin.com/in/val%C3%A9rie-caillaud-ba9809/"
                            title = "Valérie Caillaud"
                            description = {t('core.function.val')}
                            text1 = {t('core.val.text1')}
                            text2 = {t('core.val.text2')}
                            text3 = {t('core.val.text3')}
                            />
                    </div>
                </div>
                {/* End Member3 */}

                {/* Start Member4 */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <MemberBios
                            image = "/images/team/member4.png"
                            link = "https://www.linkedin.com/in/anne-marie-calmeil-25269a1/"
                            title = "Anne-Marie Calmeil"
                            description = {t('core.function.ann')}
                            text1 = {t('core.ann.text1')}
                            text2 = {t('core.ann.text2')}
                            text3 = {t('core.ann.text3')}
                            />
                    </div>
                </div>
                {/* End Member4 */}

                {/* Start Member5 */}
                <div className="rn-service-area rn-section-gap member-display">
                    <div className="container">
                        <MemberBios
                            image = "/images/team/member5.png"
                            link = "https://www.linkedin.com/in/guy-roulier-6053551/"
                            title = "Guy Roulier"
                            description = {t('core.function.guy')}
                            text1 = {t('core.guy.text1')}
                            text2 = {t('core.guy.text2')}
                            text3 = {t('core.guy.text3')}
                            />
                    </div>
                </div>
                {/* End Member5 */}

                {/* Start Member6 */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <MemberBios
                            image = "/images/team/member6.png"
                            link = "https://www.linkedin.com/in/marie-helene-morvan/"
                            title = "Marie-Hélène Morvan"
                            description = {t('core.function.mar')}
                            text1 = {t('core.mar.text1')}
                            text2 = {t('core.mar.text2')}
                            text3 = {t('core.mar.text3')}
                            />
                    </div>
                    <div className='text-center pt-5'>
                    <Link className="btn-default btn-large" to='/about-us'>{t('WhoAreWe.teamReturn')}</Link>
                    </div>  
                </div>
                {/* End Member6 */}
                 
                {/*  End Core Team  */}                    
                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default CoreTeam;